import request from "@src/utils/request";

interface PasswordFormData {
  currentPassword: string;
  newPassword: string;
  confirmPassword?: string;
}

interface DistributorAuthCredentials {
  distributor: string;
  token: string;
  [key: string]: any;
}

export interface MidwestCustomer {
  customerNumber: string;
  name: string;
  address1?: string;
  city?: string;
  state?: string;
  shipTos?: Array<{
    customerNumber: string;
    name: string;
  }>;
}

export interface ValidateMidwestCredentialsResponse {
  refreshToken: string;
  customers: {
    billTos: MidwestCustomer[];
  };
}

export function logoutUser() {
  return request().post("/logout/").send();
}

export function changeCurrentUserPassword(formData: PasswordFormData) {
  return request().post("/api/v1/current-user/change-password/").send(formData);
}

export function getAccountDistributorConnections(options?: {
  includeOAuthLink?: boolean;
}) {
  const url = options?.includeOAuthLink
    ? "/api/v1/account-distributor-connections/?includeOAuthLink=true"
    : "/api/v1/account-distributor-connections/";
  return request().get(url).send();
}

export function setDistributorAuthCredentials(
  distributorAuthCredentials: DistributorAuthCredentials,
) {
  return request()
    .post("/api/v1/distributor-auth-credentials/")
    .send(distributorAuthCredentials);
}

export function deleteDistributorAuthCredentials(
  distributorAuthCredentialId: string,
) {
  return request()
    .delete(
      `/api/v1/distributor-auth-credentials/${distributorAuthCredentialId}/`,
    )
    .send();
}

export function getCovetrusSSOHtml() {
  return request().get("/api/v1/get-covetrus-sso-html/").send();
}

export async function validateMidwestCredentials(
  loginId: string,
  password: string,
): Promise<ValidateMidwestCredentialsResponse> {
  const response = await request()
    .post("/api/v1/midwest/validate-credentials/")
    .send({ loginId, password });
  return response.body;
}

export function reacceptDistributorTerms(distributorSlug: string) {
  return request()
    .post("/api/v1/distributor-auth-credentials/reaccept-terms/")
    .send({ distributor: distributorSlug });
}
